/** What opened a reading of a printed question. */
export enum QuestionDigitisationRunTrigger {
  /** The first reading, opened when the paper was surveyed. */
  Survey = 'survey',
  /** A reading the engine opened itself, a rung up, after one that left faults or failed. */
  Retry = 'retry',
  /** A reading a person asked for. */
  Person = 'person',
}

/**
 * The states a reading of a printed question moves through. Allowed moves are
 * set in SQL by `public.is_question_digitisation_run_status_transition_allowed`.
 */
export enum QuestionDigitisationRunStatus {
  Pending = 'pending',
  Processing = 'processing',
  Processed = 'processed',
  Failed = 'failed',
}
